export default "__VITE_ASSET__D5YfC5OB__"